export const getIsMobile = (state: any): boolean =>
  state?.browser?.isMobile ?? false;

export const getIsMobileOrTablet = (state: any): boolean =>
  state?.browser?.isAnyMobile ?? false;
